function initQuickBuy() {
  document.querySelectorAll(".quick-buy").forEach(function (qb) {
    const productId = qb.dataset.productId;
    const variantIdInput = qb.querySelector(".qb-variant-id");
    let quickBuyProductData = null;

    let clickedJsonData = null; // store JSON from clicked anchor

    function updateVariant() {
      const selectedOptions = [];
      qb.querySelectorAll(".qb-btn.active").forEach((btn) => {
        const optionValue = btn.dataset.value;
        selectedOptions.push(optionValue);
      });
      if (quickBuyProductData && Array.isArray(quickBuyProductData.variants)) {
        const matchedVariant = quickBuyProductData.variants.find((v) => {
          return v.options.every((opt, idx) => opt === selectedOptions[idx]);
        });

        if (matchedVariant) {
          variantIdInput.value = matchedVariant.id;
        }
      }
      updateOptionAvailability();
      updatePriceSaleDiv(quickBuyProductData, qb);
    }

    function updateOptionAvailability() {
      if (!quickBuyProductData) return;

      // Collect current selections
      const currentSelections = {};
      qb.querySelectorAll(".qb-btn.active").forEach((btn) => {
        currentSelections[btn.dataset.option] = btn.dataset.value;
      });

      // For each option container
      qb.querySelectorAll(".qb-option").forEach((optContainer, optIndex) => {
        const optionLabel = optContainer
          .querySelector(".qb-label")
          .textContent.trim();
        const buttons = optContainer.querySelectorAll(".qb-btn");

        buttons.forEach((btn) => {
          const testValue = btn.dataset.value;

          // Build a hypothetical selection
          const testSelections = {
            ...currentSelections,
            [optionLabel]: testValue,
          };

          // Find if any variant matches this hypothetical selection and is available
          const variantExists = quickBuyProductData.variants.some((variant) => {
            if (!variant.available) return false;

            return quickBuyProductData.options.every((optName, i) => {
              const requiredValue = testSelections[optName];
              if (!requiredValue) return true; // not selected yet
              return variant["option" + (i + 1)] === requiredValue;
            });
          });

          // Enable or disable based on existence
          if (variantExists) {
            btn.disabled = false;
            btn.classList.remove("unavailable");
            btn.title = "";
          } else {
            btn.disabled = true;
            btn.classList.add("unavailable");
            btn.title = "Unavailable";
          }
        });
      });
    }

    qb.addEventListener("click", (e) => {
      const btn = e.target.closest(".qb-btn");
      if (!btn || btn.disabled) return;

      const optionContainer = btn.closest(".qb-values");
      if (!optionContainer) return;

      // Remove active class from sibling buttons within same option group
      optionContainer.querySelectorAll(".qb-btn").forEach((b) => {
        b.classList.remove("active");
      });

      btn.classList.add("active");
      updateVariant();
      const errorEl = qb.querySelector(".qb-error");
      if (errorEl) { errorEl.hidden = true; }
    });

    // Custom sort for option values
    function sortOptionValues(optionLabel, values) {
      const sizeOrder = ["XS/S", "S/M", "M/L", "L/XL", "XL/XXL", "XXL/XXXL"];
      const bandOrder = ["28", "30", "32", "34", "36", "38", "40", "42", "44"];
      const cupOrder = ["A", "B", "C", "D", "DD", "E", "F", "G"];

      // Determine type of option
      if (
        optionLabel.toLowerCase().includes("size") ||
        optionLabel.toLowerCase().includes("panties")
      ) {
        return values.sort((a, b) => {
          const indexA = sizeOrder.indexOf(a);
          const indexB = sizeOrder.indexOf(b);
          return (
            (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB)
          );
        });
      } else if (optionLabel.toLowerCase().includes("band")) {
        return values.sort((a, b) => {
          const indexA = bandOrder.indexOf(a);
          const indexB = bandOrder.indexOf(b);
          return (
            (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB)
          );
        });
      } else if (optionLabel.toLowerCase().includes("cup")) {
        return values.sort((a, b) => {
          const indexA = cupOrder.indexOf(a);
          const indexB = cupOrder.indexOf(b);
          return (
            (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB)
          );
        });
      }

      // Fallback alphabetical sort
      return values.sort();
    }

    // Example function to rerender size buttons from product JSON
    function renderOptionsFromProductJson(productJson, container) {
      // Save JSON for later use
      quickBuyProductData = productJson;

      // Get all option containers
      const optionContainers = container.querySelectorAll(".qb-option");

      // Build a map: optionName => Set of all possible option values
      const allOptionsMap = {};
      // Build a map: optionName => Set of available option values only
      const availableOptionsMap = {};

      productJson.options.forEach((optionName, optionIndex) => {
        allOptionsMap[optionName] = new Set();
        availableOptionsMap[optionName] = new Set();

        productJson.variants.forEach((variant) => {
          const optionValue = variant["option" + (optionIndex + 1)];
          allOptionsMap[optionName].add(optionValue);
          if (variant.available) {
            availableOptionsMap[optionName].add(optionValue);
          }
        });
      });

      // For each option container in DOM, update buttons
      optionContainers.forEach((optContainer) => {
        const optionLabel = optContainer
          .querySelector(".qb-label")
          .textContent.trim();
        const valuesContainer = optContainer.querySelector(".qb-values");

        // Clear current buttons
        valuesContainer.innerHTML = "";

        if (!(optionLabel in allOptionsMap)) {
          // No such option in JSON, skip
          return;
        }

        // Define preferred order array
        const preferredOrder = [
          "XS",
          "XS/S",
          "S",
          "S/M",
          "M",
          "M/L",
          "L",
          "L/XL",
          "XL",
          "XXL",
        ];

        let firstAvailableBtn = null;

        // Add buttons for each possible value of this option
        Array.from(allOptionsMap[optionLabel])
          .sort((a, b) => {
            const indexA = preferredOrder.indexOf(a);
            const indexB = preferredOrder.indexOf(b);

            if (indexA === -1 && indexB === -1) return a.localeCompare(b);
            if (indexA === -1) return 1; // put unknown at end
            if (indexB === -1) return -1;
            return indexA - indexB;
          })
          .forEach((value) => {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "qb-btn";
            btn.dataset.option = optionLabel;
            btn.dataset.value = value;
            btn.textContent = value;

            // Disable button if no available variant has this option value
            if (!availableOptionsMap[optionLabel].has(value)) {
              btn.disabled = true;
              btn.classList.add("unavailable"); // optional, for styling
              btn.title = "Unavailable";
            } else if (!firstAvailableBtn) {
              // Store the first available button
              firstAvailableBtn = btn;
            }

            valuesContainer.appendChild(btn);
          });

        // Mark first available button as active
        if (firstAvailableBtn) {
          firstAvailableBtn.classList.add("active");
        }
      });
      updateProductTitleAndLink(quickBuyProductData, container);
      updateProductImage(quickBuyProductData, container);
      updatePromoSection(quickBuyProductData, container);
      // Don't update price here - wait until a size/option is actually selected
    }

    function updateProductTitleAndLink(productJson, container) {
      // Find the product link inside the card
      const productLinkEl = container
        .closest(".card__content")
        ?.querySelector(".card__heading a");

      if (productLinkEl) {
        // Update title text
        productLinkEl.textContent = productJson.title;

        // Build product URL
        const baseUrl = productJson.url || `/products/${productJson.handle}`;
        productLinkEl.href = baseUrl;
      }
    }

    function updateProductImage(productJson, container) {
      const cardWrapper = container.closest(".card-wrapper");
      if (!cardWrapper) return;

      const imageEls = cardWrapper.querySelectorAll(".card__media img"); // main & hover

      if (productJson.images && productJson.images.length > 0) {
        // Update main image (always present)
        if (imageEls[0]) {
          imageEls[0].src = productJson.images[0];
          imageEls[0].srcset = ""; // reset lazyload
          imageEls[0].alt = productJson.title;
        }

        // Update hover image only if available in DOM and product JSON
        if (imageEls[1] && productJson.images.length > 1) {
          imageEls[1].src = productJson.images[1];
          imageEls[1].srcset = "";
          imageEls[1].alt = productJson.title;
        }
      }
    }

    function updatePriceSaleDiv(productJson, container) {
      if (!productJson || !productJson.variants) return;

      // Get the currently selected options
      const selectedOptions = [];
      container.querySelectorAll(".qb-btn.active").forEach((btn) => {
        const optionValue = btn.dataset.value;
        selectedOptions.push(optionValue);
      });

      // Find matching variant based on selected options
      let variant = null;
      if (selectedOptions.length > 0) {
        variant = productJson.variants.find((v) => {
          return v.options.every((opt, idx) => opt === selectedOptions[idx]);
        });
      }
      
      // If no variant matched yet, use first available
      if (!variant) {
        variant =
          productJson.variants.find((v) => v.available) ||
          productJson.variants[0];
      }
      
      if (!variant) return;

      // Find the card__content by traversing up from the container
      let saleDiv = null;
      const quickBuy = container.closest(".quick-buy");
      if (quickBuy) {
        const cardContent = quickBuy.closest(".card__content");
        if (cardContent) {
          saleDiv = cardContent.querySelector(".price__sale");
        }
      }
      
      if (!saleDiv) {
        return;
      }

      const salePriceSpan = saleDiv.querySelector(".price-item--sale");
      const comparePriceSpan = saleDiv.querySelector(".price-item--regular");
      const compareAtText = saleDiv.querySelector(".compare-at-text");
      let discountEl = saleDiv.querySelector(".discount-percentage");
      
      // Get the price__regular container to hide/show
      const priceRegularDiv = saleDiv.closest(".price__container")?.querySelector(".price__regular");
      
      // Get the sale badge element
      const cardWrapper = saleDiv.closest(".card");
      const saleBadge = cardWrapper?.querySelector(".card__badge");

      const price = (variant.price / 100).toFixed(2);
      const comparePrice = variant.compare_at_price
        ? (variant.compare_at_price / 100).toFixed(2)
        : null;
      console.log(comparePrice,"comparePrice")
      if (!comparePrice && comparePrice <= price) {
        // Only show regular price
        if (priceRegularDiv) priceRegularDiv.style.display = "";
        if (saleDiv) {
          saleDiv.style.display = ""; // Show the container
          // Hide sale-specific elements
          if (salePriceSpan) salePriceSpan.style.display = "none";
          if (compareAtText) compareAtText.style.display = "none";
          if (discountEl) discountEl.style.display = "none";
        }
        if (saleBadge) saleBadge.style.display = "none";
      } else {
        // Show sale price, compare price, and discount
        const discount = Math.round(
          ((comparePrice - price) / comparePrice) * 100
        );

        // Hide regular price div, show sale div with !important override
        if (priceRegularDiv) priceRegularDiv.style.display = "none";
        if (saleDiv) saleDiv.style.setProperty("display", "block", "important");
        if (saleBadge) {
          saleBadge.style.display = "";
          // Check if there's already a span inside, otherwise create one
          let badgeSpan = saleBadge.querySelector("span");
          if (!badgeSpan) {
            badgeSpan = document.createElement("span");
            badgeSpan.className = "badge badge--bottom-left color-inverse";
            badgeSpan.setAttribute("tabindex", "0");
            saleBadge.appendChild(badgeSpan);
          }
          badgeSpan.textContent = "Sale";
        }

        if (salePriceSpan) {
          salePriceSpan.textContent = `$${price}`;
          salePriceSpan.style.display = "";
        }
        if (comparePriceSpan) comparePriceSpan.textContent = `$${comparePrice}`;
        if (compareAtText) compareAtText.style.display = "";
        
        // Create discount element if it doesn't exist
        if (!discountEl) {
          discountEl = document.createElement("span");
          discountEl.className = "discount-percentage";
          discountEl.style.color = "#ff0000";
          saleDiv.appendChild(discountEl);
        }
        
        discountEl.textContent = `Save ${discount}%`;
        discountEl.style.display = "";
      }
    }

    function updatePromoSection(productJson, container) {
      if (!productJson || !productJson.tags) return;

      const promoTag = productJson.tags.find((tag) => tag.startsWith("promo#"));
      const promoDiv = container.querySelector(".continerPromo");

      if (!promoDiv) return; // no promo container, nothing to update

      if (!promoTag) {
        // No promo tag: clear contents
        promoDiv.innerHTML = "";
        promoDiv.style.display = "none";
        return;
      }

      // Extract numbers from tag: promo#3&48@20
      const match = promoTag.match(/promo#(\d+)&(\d+)@(\d+)/);
      if (!match) {
        promoDiv.innerHTML = "";
        promoDiv.style.display = "none";
        return;
      }

      const [, quantity, total, regular] = match;

      promoDiv.innerHTML = `
    <div tabindex="0" aria-label="${quantity} items, $ ${total}" class="x-for-y-text" >${quantity} / $ ${total}</div>
    <div tabindex="0" class="x-for-y-reg-text" >or Regular $ ${regular} each</div>
  `;
      promoDiv.style.display = ""; // show
    }

    // When clicking anchor, store JSON into variable
    qb.querySelectorAll("a").forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();

        const li = this.closest("li");
        if (!li) return;

        const scriptTag = li.querySelector('script[type="application/json"]');
        if (!scriptTag) {
          console.error("No JSON script tag found");
          return;
        }

        try {
          const productJson = JSON.parse(scriptTag.textContent);
          const swatches = this.closest(".swatches");
          if (!swatches) return;

          swatches
            .querySelectorAll("a")
            .forEach((a) => a.classList.remove("active"));
          this.classList.add("active");

          const quickBuy = this.closest(".quick-buy");
          if (!quickBuy) {
            console.error("No .quick-buy parent found");
            return;
          }

          // Suppose you have a container div for sizes in your quick-buy section:
          const optionsContainer = quickBuy.querySelector(
            ".quick-buy-options-container"
          );
          if (!optionsContainer) {
            console.error("Sizes container not found");
            return;
          }

          renderOptionsFromProductJson(productJson, optionsContainer);
          updateVariant(); // update variant with new default selections
          updatePriceSaleDiv(quickBuyProductData, optionsContainer); // update price based on new product
        } catch (err) {
          console.error("Invalid JSON in script tag:", err);
        }
      });
    });

    function cartNotificatinUpdate() {
      const url = `/cart.js`;

      fetch(url)
        .then((response) => response.json())
        .then((response) => {
          if (response.item_count > 0) {
            if (document.querySelector(".cart-count-bubble")) return;
            const cartLink = document.getElementById("cart-icon-bubble");
            const cartCountBubble = document.createElement("div");
            cartCountBubble.classList.add("cart-count-bubble");
            cartCountBubble.innerHTML = `
                                            <span aria-hidden="true">${response.item_count}</span>
                                            <span class="visually-hidden">${response.item_count} item</span>
                                            `;

            // Append the created <div> element inside the <a> element
            cartLink.appendChild(cartCountBubble);
          }
        })
        .catch((error) => {
          console.error(`Error checking ${url}:`, error);
        });
    }
    const crt =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    qb.querySelector(".qb-add-to-cart").addEventListener("click", () => {
      const errorEl = qb.querySelector(".qb-error");
      const variantId = variantIdInput.value;
      const selectedVariant = quickBuyProductData?.variants.find(
        (v) => v.id == variantId
      );

      if (!selectedVariant) {
        if (errorEl) {
          errorEl.hidden = false;
        }
        return;
      }

      if (!selectedVariant.available) {
         if (errorEl) {
          errorEl.hidden = false;
        }
        return;
      }

      

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((res) => res.json())
        .then((data) => {
          //crt.updateContentByAjex();
           window.AMP_API.OPEN_CART();
          cartNotificatinUpdate();
        });
    });
    // AUTO-INIT ON DEFAULT SWATCH
    const defaultSwatch = qb.querySelector(".swatches a.active");
    if (defaultSwatch) {
      const li = defaultSwatch.closest("li");
      if (li) {
        const scriptTag = li.querySelector('script[type="application/json"]');
        if (scriptTag) {
          try {
            const productJson = JSON.parse(scriptTag.textContent);
            const optionsContainer = qb.querySelector(
              ".quick-buy-options-container"
            );

            if (optionsContainer) {
              renderOptionsFromProductJson(productJson, optionsContainer);
              updateVariant(); // select default variant
              updateOptionAvailability(); // disable incompatible options
              updatePriceSaleDiv(quickBuyProductData, optionsContainer); // update price based on default selection
            }
          } catch (err) {
            console.error("Invalid default JSON:", err);
          }
        }
      }
    }
  });
}
document.addEventListener("DOMContentLoaded", function () {
  initQuickBuy();
});
